import * as React from "react";
import { Switch } from "react-router-dom";
import PositionContainer from "../components/toc/position/positionContainer/positionContainer";
import PostLogin from "./postLogin";

const PositionRouting = () => {
	return (
		<Switch>
			<PostLogin path="/position" component={PositionContainer} />
		</Switch>
	);
};
export default PositionRouting;
